import React from 'react';

const Button = ({className, disabled = false, ...props}) => {
    return (
        <button {...props}
                className={` bg-ea_yellow  p-2 rounded-lg uppercase font-bold 
                ${disabled ? "opacity-20" : "hover:bg-ea_green_to cursor-pointer hover:text-white"} ${className}`}>
            {props.children}
        </button>
    );
};

export default Button;